import React from 'react';
import { StandardSection } from '@commons/standard-section/StandardSection';
import { Button } from '@commons/button/Button';

import * as styles from './technology-blog.module.scss';

export const TechnologyBlogSection = () => (
  <StandardSection id="technology-blog-section" className={styles.section} title="Technology blog">
    <p>
      We encourage you to visit our blog and delve into the more technical details of how we have approached a number of
      sophisticated challenges.
    </p>
    <Button className={styles.button} label="Visit our blog" href="/blog/" />
  </StandardSection>
);
